import { useQuery, useQueryClient } from 'react-query';

import useAuth from '@/hooks/useAuth';
import { userApi } from '@/services';

export const useQuerySubtaskDocs = (id, tid, sid, options = {}) => {
  const { authenticated } = useAuth();

  return useQuery(
    ['documents', sid],
    async () => {
      try {
        const { data } = await userApi.get(`/documents/projectrelation/${id}/task/${tid}/subtask/${sid}`);
        return data.data;
      } catch (e) {
        throw new Error(e.message);
      }
    },
    {
      ...options,
      enabled: authenticated && !!id,
    }
  );
};

export const useQueryProject = (id, options = {}) => {
  const { authenticated } = useAuth();

  return useQuery(
    ['project', id],
    async () => {
      const { data } = await userApi(`/projects/${id}`);
      return data.data;
    },
    { ...options, enabled: authenticated && !!id }
  );
};

const useQueryProjectList = () => {
  const { authenticated } = useAuth();
  const queryClient = useQueryClient();

  return useQuery(
    ['project'],
    async () => {
      const { data } = await userApi('/projects');

      return data.data;
    },
    {
      enabled: authenticated,
      onSuccess: (data) => {
        data?.forEach?.((item) => {
          queryClient.setQueryData(['project', item.id], item);
        });
      },
    }
  );
};

export default useQueryProjectList;
